import { combineReducers } from "redux";
import { getProductReducer, userRegisterReducer, userSignInReducer } from "./Userreducer";
import { getCategoryReducer, postCategoryReducer, postItemReducer } from "./AdminReduser";

const rootReducer = combineReducers({
    userRegister: userRegisterReducer,
    userAuth: userSignInReducer,
    postItem: postItemReducer,
    postCategory: postCategoryReducer,
    getCategory: getCategoryReducer,
    getProduct: getProductReducer
})
export {rootReducer}